// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1r0Wg","inputWrap":"Table_inputWrap__2BWgA","col":"Table_col__ZM1xg","bmiTooltip":"Table_bmiTooltip__3Gavb"};